"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCloudSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M10.502 3c-4.144 0-7.506 3.334-7.506 7.451l.01.364.01.114-.05.024A5.215 5.215 0 000 15.65c0 2.697 2.087 4.2 4.851 4.2h13.915c2.932 0 5.234-2.386 5.234-5.686l-.004-.236c-.122-3.52-2.974-6.348-6.517-6.47l-.107-.001-.107-.232A7.508 7.508 0 0010.502 3z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCloudSolid;
exports.default = _default;